<template>
    <AppLayoutBase>
        <template slot="main">
            <AuthLoginContent/>
        </template>
        <template slot="navbar">
            <AppLayoutNavbar>
                <template slot="apps">
                    <div></div>
                </template>
            </AppLayoutNavbar>
        </template>
    </AppLayoutBase>
</template>

<script>
    export default {
        name: "Login",
        created() {
        }
    }
</script>

<style scoped>

</style>